export const FORM_LINE_TYPES = {
	textfield: 'textfield',
	datepicker: 'datepicker',
	timepicker: 'timepicker',
	select: 'select',
	autocomplete: 'autocomplete',
	radio: 'radio',
	checkbox: 'checkbox',
	typed: 'typed',
	repeater: 'repeater',
	custom: 'custom',
	upload: 'upload',
	range: 'range',
};

export const KNOWN_TYPES = Object.values(FORM_LINE_TYPES);
